import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TheLoopService } from '@vendasta/the-loop';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { newChannelOption } from '../post-type-editor.component';

@Component({
  selector: 'app-loop-post-type-general-settings',
  styleUrls: ['./post-type-general-settings.component.scss'],
  templateUrl: './post-type-general-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PostTypeGeneralSettingsComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  channels$: Observable<string[]>;
  newChannelOption = newChannelOption;

  constructor(private loopService: TheLoopService) {}

  ngOnInit(): void {
    this.channels$ = this.loopService.getChannels().pipe(
      map((channels) => {
        channels.push(this.newChannelOption);
        return channels;
      }),
    );
  }
}
